<template>
    <div class="cart-item-option-group">
        <div class="name" v-if="optionGroup.displayName">{{ getNameInLocationLanguage(optionGroup, props.showInternalNames)
            }}</div>
        <div class="entries" v-if="optionGroup.items.length">
            <CartItemOption
                v-for="option in optionGroup.items"
                :key="option.id"
                :option="option"
                :multiplier="multiplier"
                :showInternalNames="props.showInternalNames"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
    import type { ICartItemOptionGroup } from "@/data/model/Customer";
    import { getNameInLocationLanguage } from "@/shared/helpers/ItemNameHelper";

    import CartItemOption from "./CartItemOption.vue";

    // define properties
    const props = defineProps<{
        optionGroup: ICartItemOptionGroup;
        multiplier: number;
        showInternalNames: boolean;
    }>();
</script>

<style lang="scss">
    @use "./../../../assets/styles/scss/shared/_variables.scss";

    .cart-item-option-group {
        font-size: 12px;

        > .name {
            font-style: italic;
            line-height: 1.5em;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
</style>
